module.exports = __webpack_public_path__ + "static/img/default-prod.dd7b574d.png";